import type { ReactNode } from 'react'
import React from 'react'

import type { Variant } from '../../../themes/types'
import type { IconName } from '../../core'
import { Icon } from '../../core'
import Text from '../../core/Text/Text'
import { Inline } from '../../layout'
import { StyledLink } from './Link.styles'

export interface LinkProps {
  'data-e2e'?: string
  bold?: boolean
  children?: ReactNode
  className?: string
  href: string
  icon?: IconName
  iconOutline?: boolean
  onClick?: () => void
  underline?: boolean
  variant?: Variant
  wrap?: boolean
}

const Link = ({
  'data-e2e': datae2e,
  bold = false,
  children,
  className,
  href,
  icon,
  iconOutline = false,
  onClick,
  underline = true,
  variant = 'primary',
  wrap,
}: LinkProps) => (
  <StyledLink
    className={className}
    data-e2e={datae2e}
    href={href}
    onClick={onClick}
    rel="noreferrer noopener"
    role="link"
    target="_blank"
    underline={underline}
    variant={variant}
  >
    <Inline alignment="center" spacing="xsmall" noWrap>
      {!!icon && <Icon name={icon} faStyle={iconOutline ? 'far' : 'fas'} variant={variant} />}

      <Text underline={underline} bold={bold} wrap={wrap}>
        {children}
      </Text>
    </Inline>
  </StyledLink>
)

export default Link
